<template>
<div class="content">
    <div class="container-fluid" v-if="loading">
        <div class="row">
            <div class="col-xl-12">
                <h2>Loading...</h2>
            </div>
        </div>
    </div>
    <div class="container-fluid rotated-labels" v-if="!loading">
        <div class="row">
            <b-col style='max-width:130px;'>
                Start Date:</b-col>
            <b-col style='max-width:150px'>
                {{displayDate(start_date)}}
                <vc-date-picker
                @input="formDirty=true"
                v-model="start_date"
                is-expanded=false
                :popover="{ placement: 'bottom', visibility: 'click' }">
                    <button class="rounded focus:outline-none fill-current">>
                    </button>
                </vc-date-picker>
            </b-col>
            <b-col style='max-width:130px;'>
                End Date:</b-col>
            <b-col style='max-width:150px'>
                {{displayDate(end_date)}}
                <vc-date-picker
                @input="formDirty=true"
                v-model="end_date"
                is-expanded=false
                :popover="{ placement: 'bottom', visibility: 'click' }">
                    <button class="rounded focus:outline-none fill-current">>
                    </button>
                </vc-date-picker>
            </b-col>
        </div>
        <chart-card 
            data-cy='savingsplan-chart'
            :key='update_savings_plans' 
            :chart-data="savings_plan_chart.data" 
            :chart-options="savings_plan_chart.options" 
            :responsive-options="savings_plan_chart.responsiveOptions"
            >
            <template slot="header">
                <h4 class="card-title" >AWS Savings Plans Performance</h4>
                <p class="card-category" >(LetGo exc.)</p>
            </template>
            <template slot="footer">
                <div class="legend">
                    <i class="fa fa-circle text-info"></i> Discounted Price
                    <i class="fa fa-circle text-danger"></i> On Demand
                    <!-- <i class="fa fa-circle text-warning"></i> AWS Commitment (no VAT) -->
                </div>
                <hr>
                <div class="stats">
                    <i class="fa fa-history"></i> Updated daily / page refreshed at {{last_update}}
                </div>
            </template>
        </chart-card>
        <div class="row">
            <div class="col-xl-6 col-md-4 col-lg-4 col-sm-6">
                <stats-card>
                    <div slot="content">
                        <p class="card-category">Total Savings</p>
                        <h4 class="card-title">{{ money(totalSavings) }}</h4>
                    </div>
                </stats-card>
            </div>
            <div class="col-xl-6 col-md-4 col-lg-4 col-sm-6">
                <stats-card>
                    <div slot="content">
                        <p class="card-category">Total On Demand</p>
                        <h4 class="card-title">{{ money(totalOnDemand) }}</h4>
                    </div>
                </stats-card>
            </div>
            <div class="col-xl-6 col-md-4 col-lg-4 col-sm-6">
                <stats-card>
                    <div slot="content">
                        <p class="card-category">Discount Ratio</p>
                        <h4 class="card-title">{{ (totalSavings / totalOnDemand * 100).toFixed(2) }}%</h4>
                    </div>
                </stats-card>
            </div>
            <div class="col-xl-6 col-md-4 col-lg-4 col-sm-6">
                <stats-card>
                    <div slot="content">
                        <p class="card-category">Average Usage</p>
                        <h4 class="card-title">{{ averageUsage.toFixed(2) }} %</h4>
                    </div>
                </stats-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import ChartCard from 'src/components/Cards/ChartCard.vue'
import StatsCard from 'src/components/Cards/StatsCard.vue'
import LTable from 'src/components/Table.vue'
import axios from 'axios'
import Multiselect from 'vue-multiselect'

import {
    colors,
    formatMoney,
    formatSimple,
    formatSimple2d,
    chart_base
} from 'src/globalVariables'
import {
    setInterval
} from 'timers';
import chartist from 'chartist'

Number.prototype.pad = function (size) {
    var s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
}

export default {
    components: {
        LTable,
        ChartCard,
        StatsCard,
        Multiselect,
    },
    async created() {
        this.accessToken = await this.$auth.getAccessToken()
        this.loadData()
        var vm = this
        setInterval(function () {
            vm.loadData()
        }, vm.refresh_minutes * 60 * 1000)

    },
    methods: {
        money(number){
            return formatMoney.format(number)
        },
        refresh_chart(){
            var labels = []
            var onDemandCostEquivalent = []
            var netSavings = []
            var discountedPrice = []
            var vm = this
            this.totalSavings = 0
            this.totalOnDemand = 0
            this.averageUsage = 0
            this.savings_plans.forEach(function (entry){
                if (new Date(entry.referenceDate) >= vm.start_date && new Date(entry.referenceDate) <= vm.end_date)
                {
                    var key = new Date(entry.referenceDate).toLocaleDateString("de-DE")
                    labels.push(key)
                    netSavings.push(entry.netSavings)
                    discountedPrice.push(entry.onDemandCostEquivalent - entry.netSavings)
                    onDemandCostEquivalent.push(entry.onDemandCostEquivalent)

                    // calculates totals and prepare average
                    vm.totalSavings+= entry.netSavings
                    vm.totalOnDemand+= entry.onDemandCostEquivalent
                    vm.averageUsage+= entry.usage
                }
            })
            this.averageUsage = this.averageUsage / labels.length
            this.savings_plan_chart={
                'data': {
                    'labels': labels,
                    'series': [discountedPrice,onDemandCostEquivalent]
                },
                'options': Object.assign({}, chart_base.options),
                'responsiveOptions': Object.assign({}, chart_base.responsiveOptions),
            }
            // this.savings_plan_chart.options.stackBars= true
            this.savings_plan_chart.options.seriesBarWidth=20
            this.savings_plan_chart.options.seriesBarDistance=10
        },        
        displayDate(dt){
            return new Date(dt).toLocaleDateString('de-DE')
        },
        loadData: function () {
            var today = new Date();
            this.last_update = today.getHours().pad(2) + ":" + today.getMinutes().pad(2) + ":" + today.getSeconds().pad(2)
            console.log('refreshing...', )
            axios
                .get('/aws/savingsplan/performance?access_token=' + this.accessToken)
                .then(response => {
                    this.savings_plans = response.data
                })
            this.loading = false;
            return true
        },
    },
    watch: {
        start_date: function(){
            if (this.start_date != null) this.refresh_chart()
            this.update_savings_plans +=1
            formatMoney.format(3)
        },
        end_date:  function(){
            if (this.end_date != null) this.refresh_chart()
            this.update_savings_plans +=1
        },
        savings_plans: function(){
            this.refresh_chart()
            this.update_savings_plans +=1
        },
        regions_filter: function(){
            this.filterReservations()
        },
        services_filter: function(){
            this.filterReservations()
        },
        nodetypes_filter: function(){
            this.filterReservations()
        },
    },
    computed: {

    },
    data() {
        return {
            start_date: new Date(new Date().setDate(new Date().getDate()-30)),
            end_date:new Date(),
            savings_plan_chart :{},
            accessToken: '',
            refresh_minutes: 30,
            last_update: '',
            colors: colors,
            loading: true,
            regions_filter:[],
            services_filter:[],
            nodetypes_filter:[],
            fields:[
                {key: "referenceDate", sortable: true,
                    thStyle: { 'min-width':'120px', 'max-width':'120px'},
                },
                {key: "usage", sortable: true},
                {key: "netSavings", sortable: true},
                {key: "onDemandCostEquivalent", sortable: true},
            ],
            savings_plans: [],
            update_savings_plans: 1,
            filteredReservations: [],
            totalOnDemand:0,
            totalSavings:0,
            averageUsage:0,
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.multiselect {
    max-width: 80%;
}
</style>
